import FhirDateTime from './FhirDateTime';

class FhirUtcDateTime extends FhirDateTime {
  constructor(options = {}) {
    super(options);
  }

  getDisplayValue(fhirProperty: fhir.dateTime) {
    return super.getDisplayValue(fhirProperty, true);
  }
}

export default FhirUtcDateTime;
